/* eslint-disable */
/**
 * AUTO-GENERATED — DO NOT EDIT BY HAND.
 *
 * Source of truth: src/features/app-takeover/takeovers/<id>/manifest.ts
 * Regenerate with: yarn takeover:generate
 * CI verifies freshness with: yarn takeover:validate --all
 */
import type { AppTakeoverConfig } from './types';
import { elevation } from './takeovers/elevation/elevation';
import { mandalorian } from './takeovers/mandalorian/mandalorian';

export interface RegisteredTakeover {
  config: AppTakeoverConfig;
  ldName: string;
  regions: readonly ('US' | 'CA')[];
}

/** Keyed by the LaunchDarkly `app-takeover` flag entry name (`ldName`). */
export const appTakeoverRegistry: Record<string, RegisteredTakeover> = {
  ["elevation"]: { config: elevation, ldName: "elevation", regions: ["CA"] },
  ["mandalorian"]: { config: mandalorian, ldName: "mandalorian", regions: ["US", "CA"] },
};
